module.exports = __webpack_public_path__ + "./fonts/3464e958790f74655a76934bbe1265df.woff2";